import { axios } from '@/lib/axios';

import { AuthUser } from '../types';

export type LoginCredentials = {
  email: string;
  password: string;
};

export const loginWithEmailAndPassword = (
  data: LoginCredentials
): Promise<AuthUser> => {
  return axios.post('/api/v1/auth/sign_in', data);
};
